(function($) {
    $(function() {
			$('#search_select>button').on('click', function(e) {
				e.preventDefault();
				$('.search-field').attr('placeholder', $(this).text()).val('').focus();
				$('.search-type').val($(this).data('search-type'));
				$('#search_select').foundation('close');
			});
    });
} )( jQuery );